<div class="dropdown" [class.show]="isOpen">
    <button
      class="custom-drp dropdown-toggle"
      type="button"
      (click)="toggleDropdown()"
    >
    <span class="text-truncate plc">
      {{ label }}
    </span>
    </button>

    <ul class="dropdown-menu w-100" [class.show]="isOpen">
      <li>
        <ul nz-menu [nzMode]="'vertical'" class="w-100">
          <li *ngFor="let menuItem of data" nz-submenu [nzTitle]="menuItem.label" [nzIcon]="menuItem.icon">
            <ul>
                <li *ngFor="let group of menuItem.options" nz-menu-group [nzTitle]="group.label">
                    <ul>
                        <li nz-menu-item *ngFor="let option of group.options" (click)="setValue(option)" (keydown)="setValue(option)" [ngClass]="{ 'highlight': selectedValue && (option?.value === selectedValue || option?.id === selectedValue) }">
                            <img *ngIf="option.icon" [src]="option.icon | assetUrl" [alt]="option.icon">
                            <span> {{ option.label }} </span>
                        </li>
                    </ul>
                </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </div>